












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class InstitutionEvolutionCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {};

  buldChartOptions() {
    this.chartOptions = {
      legend: {
        position: 'bottom'
      },
      height: 350,
      chartArea: { left: '60', top: '20', right: '20', bottom: '100' },
      fontSize: 12,
      hAxis: {
        slantedText: true,
        slantedTextAngle: 45
      },
      vAxis: {
        title: 'Prescrições',
        minValue: 0,
        titleTextStyle: {
          italic: false
        }
      },
      tooltip: {
        isHtml: true
      }
    };
  }

  mounted() {
    this.load();
  }

  load() {
    if (!this.kpis) {
      return;
    }
    this.buldChartOptions();
    this.chartData = [];
    let map = new Map();
    let idsDates = new Set<string>();
    let mapDsDates = new Map();
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      if (!map[i.idPeriodo]) {
        map[i.idPeriodo] = [];
      }
      if (!map[i.idPeriodo][i.nomeInstituicao]) {
        map[i.idPeriodo][i.nomeInstituicao] = [];
      }
      map[i.idPeriodo][i.nomeInstituicao] = i.quantidade;
      idsDates.add(i.idPeriodo);
      mapDsDates[i.idPeriodo] = i.descPeriodo;
      names.add(i.nomeInstituicao);
    });

    let arrayIdDates = Array.from(idsDates).sort();

    let headers: any = ['Período'];
    names.forEach((n) => {
      headers.push(n.substring(0, n.indexOf('-')).trim());
      headers.push({ type: 'string', role: 'tooltip', p: { html: true } });
    });
    this.chartData.push(headers);
    arrayIdDates.forEach((d) => {
      let day = [];
      day.push(mapDsDates[d]);
      names.forEach((n) => {
        let v = map[d][n];
        if (!v) {
          v = 0;
        }
        day.push(v);
        day.push(this.getTooltip(n, v));
      });
      this.chartData.push(day);
    });
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getTooltip(name, value) {
    return `<div style="padding:8px; white-space:nowrap"><b>${name}</b><br>Quantidade: <b>${value}</b></div>`;
  }
}
